const riot = require('riot');

riot.tag2('item-notification', '<div class="f ft bg-white rounded-8 p16 hover-trigger transition hover-box-shadow"> <div class="s40 flex-fixed mr16"><img class="s-full circle object-fit-cover" if="{getUser()}" riot-src="{app.utils.getImageUrl(getUser().data.icon_image)}"></div> <div class="w-full overflow-hidden"> <div class="f fm fbw w-full mb8"> <div> <div if="{getProject()}" data-is="atom-project" item="{getProject()}"></div> </div> <div class="f fm"><span class="font-lato fs10 text-label_dark_medium" data-is="atom-time" date="{this.opts.item.data.created_at}"></span> <div class="f fm ml12 mrn4" if="{opts.item.data.kind !== &quot;joined_workspace_user&quot;}"><i class="icon-more_vertical px4 text-label_dark_medium fs16 cursor-pointer hover-trigger hover-text-background_dark_primary tooltip" if="{isShowActionSheet()}" onclick="{onOpenActionSheet}" aria-label="メニュー" data-tooltip-position="top" data-tooltip-offset-top="0"></i><i class="icon-fullscreen px4 text-label_dark_medium fs16 cursor-pointer hover-trigger hover-text-background_dark_primary tooltip" onclick="{onOpenNote}" aria-label="開く" data-tooltip-position="top" data-tooltip-offset-top="0"></i></div> </div> </div> <div class="px16 lh15 word-break-all overflow-hidden mxn16"> <p class="mb8" if="{opts.item.data.kind === &quot;post_note&quot;}"><a class="bold" href=""><b>@{getUser().data.screen_name} </b></a>が <a class="text-primary" href="{getNoteLink()}"><b>{getNoteTitle()} </b></a>を <b>投稿</b> しました。</p> <div if="{opts.item.data.kind === &quot;post_message&quot;}"> <p class="mb8"><a href=""><b>@{getUser().data.screen_name} </b></a>が <a class="text-primary" href="{getNoteLink()}"><b>{getNoteTitle()} </b></a>に <a class="text-primary" href="{getMessageLink()}"><b>コメント </b></a>しました。</p> <div class="max-height-120 text-label_dark_primary" data-is="atom-markdown" content="{getMessage()}"></div> </div> <div if="{opts.item.data.kind === &quot;post_message_mention&quot;}"> <p class="mb8"><a class="bold" href="">@{getUser().data.screen_name}</a>が <a class="text-primary" href="{getNoteLink()}"><b>{getNoteTitle()} </b></a>で <b>あなた</b>に <a class="text-primary" href="{getMessageLink()}"><b>メンション </b></a>しました。</p> <div class="max-height-120 text-label_dark_primary" data-is="atom-markdown" content="{getMessage()}"></div> </div> <div if="{opts.item.data.kind === &quot;post_message_group_mention&quot;}"> <p class="mb8"><a class="bold" href="">@{getUser().data.screen_name} </a>が <a class="text-primary" href="{getNoteLink()}"><b>{getNoteTitle()} </b></a>で <b>{getGroup().data.screen_name}グループ</b>に <a class="text-primary" href="{getMessageLink()}"><b>メンション </b></a>しました。</p> <div class="max-height-120 text-label_dark_primary" data-is="atom-markdown" content="{getMessage()}"></div> </div> <div if="{opts.item.data.kind === &quot;post_message_all_mention&quot;}"> <p class="mb8"><a class="bold" href="">@{getUser().data.screen_name} </a>が <a class="text-primary" href="{getNoteLink()}"><b>{getNoteTitle()} </b></a>で <b>全員</b>に <a class="text-primary" href="{getMessageLink()}"><b>メンション </b></a>しました。</p> <div class="max-height-120 text-label_dark_primary" data-is="atom-markdown" content="{getMessage()}"></div> </div> <p if="{opts.item.data.kind === &quot;add_project_user&quot;}"><a class="bold" href="">@{getUser().data.screen_name} </a>から<a class="text-primary" href="{getProjectLink()}"><b>{getProject().data.name} </b></a>に<b>追加</b>されました。</p> <p if="{opts.item.data.kind === &quot;assign_note&quot;}"><a class="bold" href="">@{getUser().data.screen_name} </a>から <a class="text-primary" href="{getProjectLink()}"><b>{getProject().data.name} </b></a>の <a class="text-primary" href="{getNoteLink()}"><b>{getNoteTitle()} </b></a>に <b>アサイン </b>されました。</p> <p if="{opts.item.data.kind === &quot;joined_workspace_user&quot;}"><a class="bold" href="">@{getUser().data.screen_name} </a>がチームに参加しました。</p> </div> </div> </div>', 'item-notification,[data-is="item-notification"]{display:block}', '', function(opts) {

    this.getUser = () => {
      return this.opts.item.relation.action_user;
    };

    this.getNote = () => {
      return this.opts.item.relation.note;
    };

    this.getNoteTitle = () => {
      let note = this.getNote();
      return note.getTitle();
    };

    this.getNoteLink = () => {
      let path = this.getNote().ref.path;
      return '/' + path;
    };

    this.getProject = () => {
      return this.opts.item.relation.project;
    };

    this.getProjectLink = () => {
      let path = this.getProject().path;
      return '/' + path;
    };

    this.getMessage = () => {
      return this.opts.item.relation.message.data.content;
    };

    this.getMessageLink = () => {
      return '/' + this.opts.item.data.message_ref.path;
    };

    this.getGroup = () => {
      return this.opts.item.relation.group;
    };

    this.onOpenNote = async () => {
      spat.popup.closeAll();
      let note = this.getNote();
      if (app.useragent.isMobile) {
        spat.router.push(`/${note.path}`);
      }
      else {
        let modal = spat.modal.open('modal-note', {
          note,
        });

        await modal.waitClose();
        this.update();
      }
    };

    this.onOpenActionSheet = (e) => {
      let options = [
        {
          label: 'お気に入り',
          icon: 'star_empty',
          action: () => { popup.close(); this.onFavorite(e); },
        },
      ];

      const popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 0,
        align: { x: 'right' },
        position: 'bottom',
        opts: {
          options: options,
        },
      });
    };

    this.onFavorite = async (e) => {
      await e.item.item.relation.message.favorite();
      spat.toast.message('お気に入りしました');
    };

    this.isShowActionSheet = () => {
      return !!this.opts.item.data.message_ref;
    };
});